import { State } from 'b2b-apps/shop/common/redux/types';
import { ContextState, ProfileDetailsType, ProfileType } from 'b2b-apps/shop/context/redux/types';
import { ROLE } from 'b2b-apps/shop/context/utils/roles';

const getState = (state: State): ContextState => state.context;

const getIsLoggedIn = (state: State): boolean => !!getState(state).isLoggedIn;

const getHasOnlyCoreAssortment = (state: State): boolean => (
  getIsLoggedIn(state) && !!getProfile(state)?.hasOnlyCoreAssortment
);

const getProfile = (state: State): ProfileType => getState(state).profile;

const getDebitorId = (state: State): string | null => getProfile(state)?.debitorId || null;

const getRole = (state: State): ROLE | null => getProfile(state)?.role || null;

const getProfilePermissions = (state: State): string[] => getProfile(state)?.permissions || [];

const getProfileCertificates = (state: State): string[] => getProfile(state)?.certificates || [];

const getIsEndCustomer = (state: State): boolean => getProfile(state)?.isEndCustomer === true;

const getIsBlocked = (state: State): boolean => getProfile(state)?.isBlocked || false;

const getIsFirstOrder = (state: State): boolean => getProfile(state)?.isFirstOrder === true;

const getSid = (state: State): string => getState(state).sid;

const getProfileDetails = (state: State): ProfileDetailsType => ({
  isLoggedIn: getIsLoggedIn(state),
  role: getRole(state),
  debitorId: getDebitorId(state),
  certificates: getProfileCertificates(state),
  permissions: getProfilePermissions(state),
  isEndCustomer: getIsEndCustomer(state),
  isFirstOrder: getIsFirstOrder(state),
  isBlocked: getIsBlocked(state),
});

export {
  getDebitorId,
  getHasOnlyCoreAssortment,
  getIsBlocked,
  getIsEndCustomer,
  getIsFirstOrder,
  getIsLoggedIn,
  getProfile,
  getProfileCertificates,
  getProfileDetails,
  getProfilePermissions,
  getRole,
  getSid,
};
